import React, { useEffect, useState } from "react";
import classNames from "classnames";
import PropTypes from "prop-types";
import { NavLink, useLocation, useOutletContext } from "react-router-dom";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import Drawer from "@material-ui/core/Drawer";
import Hidden from "@material-ui/core/Hidden";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import Collapse from "@material-ui/core/Collapse";
// core components
import DesktopHeader from "../Header/DesktopHeader";
import brandTheme from "brandTheme/Theme";
import { ExpandLess, ExpandMore, Opacity } from "@material-ui/icons";
import { useSelector } from "react-redux";
import { apiHandler } from "assets/api";
import { endpoint } from "assets/api/endpoint";
import { parseAndSetFlag } from "utils/Utils";

const useStyles = makeStyles(({ theme }) => ({
  itemIcon: {
    width: "24px",
    height: "30px",
    fontSize: "24px",
    lineHeight: "30px",
    float: "left",
    marginRight: "15px",
    textAlign: "center",
    verticalAlign: "middle",
    color: brandTheme.white,
  },
  itemText: {
    fontFamily: brandTheme.font.poppins,
    fontWeight: "bold",
    margin: "0",
    lineHeight: "30px",
    fontSize: "12px",
    color: brandTheme.mainColor,
    opacity:1,
    "& .MuiListItem-root": {
      padding: "0px",
    },
  },
  activeItemText: {
    fontFamily: brandTheme.font.poppins,
    fontWeight: "bold",
    margin: "0",
    lineHeight: "30px",
    fontSize: "12px",
    color: brandTheme.mainColor,
    "& .MuiListItem-root": {
      padding: "0px",
    },
  },
  sidebarWrapper: {
    position: "relative",
    width: "260px",
    height: "80vh",
    overflowY: "auto",
    overflowX: "hidden",
    "&::-webkit-scrollbar": {
      width: "6px",
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor:  brandTheme.mainColor,
      borderRadius: "10px",
    },
  },
  dashboardMenu: {
    fontWeight: "bold",
    fontFamily: brandTheme.font.poppins,
    fontSize: "18px",
  },
  item: {
    position: "relative",
    marginBottom: "8px",
    display: "block",
    textDecoration: "none",
    backgroundColor: brandTheme.sideBarColor,
    "&:focus,&:visited": {
      color: brandTheme.white,
    },
  },
  activeClass: {
    position: "relative",
    display: "block",
    textDecoration: "none",
    "& .MuiListItem-root": {
      padding: "0px",
    },
  },
  children: {
    "& $activeClass": {
      paddingLeft: 35,
    },
    "& $item": {
      paddingLeft: 35,
      marginBottom: "0px",
      backgroundColor: "transparent",
    },
    "& .MuiListItem-root": {
      padding: "0px",
    },
  },
  radioInput: {
    width: "15px",
    height: "15px",
    margin: "0px 5px",
    position: "relative",
  },
  borderContainer: {
    borderBottom: `1px solid ${brandTheme?.mainColor}`,
     '& .MuiListItem-root.Mui-disabled':{
      opacity:1
    }
  },
  completed: {
    color: brandTheme?.lightBlue, // Change text color to blue when disabled
  },

  disabledItem: {
    color: `${brandTheme?.mainColor} !important`, // Ensures text color is blue
    "& .MuiListItemText-primary": {
      color: `${brandTheme?.mainColor} !important`,
    },
    '& .MuiListItem-root.Mui-disabled':{
      opacity:1
    }
  },

  disabledRadio: {
    "&::before": {
      content: '""',
      display: "block",
      width: "10px",
      height: "10px",
      borderRadius: "50%",
      backgroundColor: brandTheme?.mainColor,
      position: "absolute",
      top: "2.5px",
      left: "2.5px",
    },
  },
}));

const SideBarNewLoan = ({
  handleDrawerToggle,
  open,
  featureFlag,
  checkFlagData,
}) => {
  const [menuData, setMenuData] = useState(checkFlagData);
  const [masterOpen, setMasterOpen] = useState(true);
  const { leadId, leadStatus } = useSelector(
    (state) => state?.login?.userCurrentLead
  );
  const { authToken } = useSelector((state) => state.login.authData);
  const enableEstampFlag = parseAndSetFlag(featureFlag?.enableEstampFlag);
  console.log(enableEstampFlag, "afljfbaj");
  const location = useLocation();
  const classes = useStyles();
  const loanData = JSON.parse(localStorage.getItem("loanData") || "{}");
  useEffect(() => {
    if (leadStatus) {
      checkUserData();
    }
  }, [leadStatus, location?.pathname]);
  const checkUserData = async () => {
    try {
      const result = await apiHandler({
        url: endpoint.USER_PROFILE_SCREEN_FLAGS_API + leadId,
        method: "GET",
        authToken: authToken,
      });

      const flags = result?.data;
      let updatedSideBarLinks = menuData?.map((section) => {
        const updatedChildren = section.children.map((child) => {
          switch (child.name) {
            case "General Details":
              return { ...child, disabled: flags.applicantDetail };
            case "Selfie":
              return { ...child, disabled: flags.applicantPhotoKyc };
            case "Aadhar Details":
              return { ...child, disabled: flags.applicantAdhaarKyc};
            case "Income Verify":
              return { ...child, disabled: flags.applicantBankAnalyser && flags.bre };
            case "Reference Details":
              return { ...child, disabled: flags.applicantLeadReferal };
            case "Income Details":
              return { ...child, disabled: flags.applicantIncomeDetail };
            case "Approval Details":
              return { ...child, disabled: flags.approval };
            case "Loan Tenure":
              return { ...child, disabled: flags.loanTenure };
            case "Repayment Schedule":
              return { ...child, disabled: flags.repaymentScheduleDetail };
            case "Bank Details":
              return { ...child, disabled: flags.applicantBankDetail };
            case "Sanction Letter":
              return { ...child, disabled: flags.sanctionLetter };
            case "Estamp":
              return { ...child, disabled: flags.sanctionLetterEstamp };
            case "Esign":
              return { ...child, disabled: flags.sanctionLetterEsign };
            case "Mandate Detail":
              return { ...child, disabled: flags.mandateDetail };
            case "Disbursal Detail":
              return { ...child, disabled: flags.disbursal };
            case "Congratulation Details":
              return { ...child, disabled: flags.congratulation };
            default:
              return child;
          }
        });

        // Update parent sections based on flags
        let updatedDisabled = section.disabled;
        switch (section.name) {
          case "Requirement":
            updatedDisabled = flags.applicantIncomeDetail;
            break;
          case "Profile Detail":
            updatedDisabled = flags.applicantPhotoKyc;
            break;
          case "General Information":
            updatedDisabled = flags.applicantLeadReferal;
            break;
          case "Decision":
            updatedDisabled = flags.congratulation;
            break;
          case "Letters":
            updatedDisabled = flags.sanctionLetterEsign;
            break;
          case "Loan Details":
            updatedDisabled = flags.repaymentScheduleDetail;
            break;
          case "Bank Details":
            updatedDisabled = flags.applicantBankDetail;
            break;
          case "Disbursal":
            updatedDisabled = flags.disbursal;
            break;
          default:
            updatedDisabled = section.disabled;
        }

        return {
          ...section,
          children: updatedChildren,
          disabled: updatedDisabled,
        };
      });
      if (!enableEstampFlag) {
        updatedSideBarLinks = updatedSideBarLinks
          .filter((section) => section.name !== "Estamp")
          .map((section) => ({
            ...section,
            children: section.children?.filter(
              (child) => child.name !== "Estamp"
            ),
          }))
          .filter((section) => section.children?.length);
      }
      setMenuData(updatedSideBarLinks);
    } catch (error) {
      console.error("Error fetching user data:", error);
    }
  };

  console.log(menuData, "FJAFJA");
  const handler = (children) => {
    return children.map((subOption) => {
      if (!subOption.children) {
        return (
          <NavLink
            to="#"
            className={classNames(
              subOption.url === location.pathname
                ? classes.activeClass
                : classes.item,
              subOption.disabled && classes.disabledItem
            )}
            key={subOption.name}
            style={{
              pointerEvents: subOption.disabled ? "none" : "auto",
              cursor: subOption.disabled ? "not-allowed" : "pointer",
            }}
          >
            <ListItem button disabled={subOption.disabled}>
              <input
                type="radio"
                name="report"
                className={classNames(
                  classes.radioInput,
                  subOption.disabled && classes.disabledRadio
                )}
                // disabled={subOption.disabled}
                checked={subOption.disabled} // Fill radio button when disabled
                readOnly // Prevents unwanted modifications
              />
              <ListItemText
                primary={subOption.name}
                className={classNames(
                  subOption.url === location.pathname
                    ? classes.activeItemText
                    : classes.itemText,
                  subOption.disabled && classes.disabledItem
                )}
                disableTypography={true}
              />
            </ListItem>
          </NavLink>
        );
      }

      return (
        <div key={subOption.name} className={classes.borderContainer}>
          <ListItem
            className={classes.dashboardMenu}
            button
            disabled={subOption.disabled}
          >
            <input
              type="radio"
              name="report"
              className={classNames(
                classes.radioInput,
                subOption.disabled && classes.disabledRadio
              )}
              disabled={subOption.disabled}
              checked={subOption.disabled} // Fill radio button when disabled
              readOnly
            />
            <ListItemText
              primary={subOption.name}
              disableTypography={true}
              className={classNames(
                classes.itemText,
                subOption.disabled && classes.disabledItem
              )}
            />
          </ListItem>
          <Collapse in={masterOpen} timeout="auto" className={classes.children}>
            {handler(subOption.children)}
          </Collapse>
        </div>
      );
    });
  };

  return (
    <div>
      <Hidden mdUp implementation="css">
        <Drawer
          variant="temporary"
          anchor={"right"}
          open={open}
          onClose={handleDrawerToggle}
          ModalProps={{ keepMounted: true }}
        >
          <div className={classes.sidebarWrapper}>
            <DesktopHeader />
            {handler(menuData)}
          </div>
        </Drawer>
      </Hidden>
      <Hidden smDown implementation="css">
        <div className={classes.sidebarWrapper}>{handler(menuData)}</div>
      </Hidden>
    </div>
  );
};

SideBarNewLoan.propTypes = {
  handleDrawerToggle: PropTypes.func,
  open: PropTypes.bool,
};

export default SideBarNewLoan;
